import React from 'react'
const UneeqContext = React.createContext<any>({})
export default UneeqContext
